import React, { useState } from "react";
import CustomModal from "../../../../components/Modals/CustomModal";
import {
  sequenceEndPoints,
  taskEndpoints,
} from "../../../../utils/constants/httpConstants";
import { deleteRequest, getRequest } from "../../../../Apis";
import EventEmitter from "../../../../utils/emitter/EventEmitter";
import { EMITTER_SUCCESS } from "../../../../utils/constants";
import TypographyInline from "../../../../components/Typography/TypographyInline";
import { Button } from "../../../../components/Buttons";
import { STRINGS } from "../../strings";
import classes from "./CrmComp.module.css";
import { GREY } from "../../../../utils/constants/colors";
import { fontWeight } from "../../../../utils/constants/UI";
import { useLocation, useNavigate } from "react-router-dom";

const TaskDeleteModal = ({
  id,
  openTask,
  setOpenTask,
  contactId,
  setTaskListData,
}) => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const locationTabs = location?.search?.split("?tabs=");
  const UpdatedLocation = locationTabs[1] == STRINGS.CALLS_SMALL;
  const navigate = useNavigate();
  const deleteMethod = async () => {
    setLoading(true);
    try {
      const URL = `${sequenceEndPoints?.deleteTaskCrm}/${id}`;
      const response = await deleteRequest(URL, navigate);
      setLoading(false);

      EventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);

      setOpenTask(false);
      let url2 = `${taskEndpoints.getCompanyCrmTask}/ ${contactId}?step_type=${
        UpdatedLocation ? 3 : 2
      }`;
      const responseGet = await getRequest(navigate, url2);
      setTaskListData(responseGet?.data?.data?.records);
    } catch (error) {
      console.log(error);
    }
  };
  const modalHeaderData = {
    heading: {
      id: STRINGS.SMALL_HEAD,
      label: `Delete`,
    },
  };
  const modalBodyData = (
    <div className={classes.modalBody}>
      <TypographyInline
        size={"sm"}
        color={GREY.QUATINARY}
        fontWeight={fontWeight.MEDIUM}
        label={STRINGS.ARE_YOU_SURE_DELETE}
      />
    </div>
  );
  const modalFooterRightData = (
    <div className={classes.modalFooterRightData}>
      <Button
        label={STRINGS.CANCEL}
        variant={"ghost"}
        size={"sm36"}
        onClick={() => setOpenTask(false)}
      />
      <Button
        label={STRINGS.DELETE}
        variant={"primary"}
        size={"sm36"}
        onClick={() => deleteMethod()}
        isLoading={loading}
      />
    </div>
  );
  const modalFooterLeftData = <div></div>;
  return (
    <div>
      {" "}
      <CustomModal
        variant={"error"}
        close={() => setOpenTask(false)}
        open={openTask}
        header={modalHeaderData}
        children={modalBodyData}
        footer={{
          left: modalFooterLeftData,
          right: modalFooterRightData,
        }}
      />
    </div>
  );
};
export default TaskDeleteModal;
